/** The door's seven locks, in order — the truth each one proves. Mission n
 *  opens lock n. */
export const LOCK_WORDS = [
  "Brave",
  "Reliable",
  "Aim",
  "Connect",
  "Influence",
  "Champion",
  "Outlast",
] as const;

/** Each lock's clip ends with that lock open. Served from the test site's
 *  media store (only staging holds them — prod has no copy) rather than
 *  bundled (≈3.3 MB each). */
const VAULT_BASE = "https://test.secretmissions.com/media/secretmissions/vault";
export const VAULT_CLIPS = Array.from(
  { length: 7 },
  (_, i) => `${VAULT_BASE}/vault-unlock-${i + 1}.mp4`,
);
